import { render, staticRenderFns } from "./DeviceViewBase.vue?vue&type=template&id=4f8c0d94&scoped=true"
import script from "./DeviceViewBase.vue?vue&type=script&lang=js"
export * from "./DeviceViewBase.vue?vue&type=script&lang=js"
import style0 from "./DeviceViewBase.vue?vue&type=style&index=0&id=4f8c0d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c0d94",
  null
  
)

export default component.exports